module.exports = __webpack_public_path__ + "img/logo-login.e8bbdc86.png";